// WARNING: Do NOT edit this file outside npm-helsecore, it will be reset on build!

import type { TableOfContentProps } from '@dip/helsecore/src/components/parts/TableOfContent/TableOfContent.d';
import { TableOfContent } from '@dip/helsecore/src/components/parts/TableOfContent/TableOfContent'
import React from 'react';

export default (props: Readonly<TableOfContentProps>) => <TableOfContent {...props} />

